import React, { useState, useEffect } from 'react';
import './Hero.css';

const Hero = () => {
  const [displayText, setDisplayText] = useState('');
  const [wordIndex, setWordIndex] = useState(0);
  const [charIndex, setCharIndex] = useState(0);
  const [isDeleting, setIsDeleting] = useState(false);
  const videoRef = React.useRef(null);
  const handleEnquireNow = () => {
    // Replace with your WhatsApp number - format: country code + number (e.g., 919599513613)
    const whatsappNumber = '919599513613';
    const message = 'Hi, I would like to know more about your services.';
    const whatsappLink = `https://wa.me/${whatsappNumber}?text=${encodeURIComponent(message)}`;
    window.open(whatsappLink, '_blank');
  };

  useEffect(() => {
    const video = videoRef.current;
    if (!video) return;

    const handleVideoEnd = () => {
      // Smooth fade replay
      video.currentTime = 0;
      video.play().catch(err => console.log('Video play error:', err));
    };

    video.addEventListener('ended', handleVideoEnd);
    return () => video.removeEventListener('ended', handleVideoEnd);
  }, []);

  useEffect(() => {
    const words = ['Law', 'Strategy', 'Solutions', 'Business'];
    const currentWord = words[wordIndex];
    const typingSpeed = isDeleting ? 80 : 150;
    const delayBeforeDelete = 1500; // Wait before deleting
    const delayBeforeNextWord = 500; // Wait after deleting, before next word

    let timer;

    if (!isDeleting && charIndex < currentWord.length) {
      // Typing forward
      timer = setTimeout(() => {
        setDisplayText(currentWord.substring(0, charIndex + 1));
        setCharIndex(charIndex + 1);
      }, typingSpeed);
    } else if (!isDeleting && charIndex === currentWord.length) {
      // Finished typing, wait then start deleting
      timer = setTimeout(() => {
        setIsDeleting(true);
      }, delayBeforeDelete);
    } else if (isDeleting && charIndex > 0) {
      // Deleting
      timer = setTimeout(() => {
        setDisplayText(currentWord.substring(0, charIndex - 1));
        setCharIndex(charIndex - 1);
      }, typingSpeed);
    } else if (isDeleting && charIndex === 0) {
      // Finished deleting, move to next word
      setIsDeleting(false);
      setWordIndex((wordIndex + 1) % words.length);
      setDisplayText('');
      timer = setTimeout(() => {}, delayBeforeNextWord);
    }

    return () => clearTimeout(timer);
  }, [charIndex, isDeleting, wordIndex]);

  return (
    <section className="hero">
      <div className="hero-image">
        <video 
          ref={videoRef}
          className="hero-video" 
          autoPlay 
          loop 
          muted 
          playsInline
        >
          <source src="/justiceLady.mp4" type="video/mp4" />
          <img src="/justiceLady.jpg" alt="Justice" />
        </video>
      </div>
      <div className="hero-content">
        <h1 className="hero-title">
          <span className="typewriter-word">
            <span className="typewriter-text">{displayText}</span>
            <span className="typewriter-cursor"></span>
          </span>
        </h1>
        <p className="hero-subtitle">Legal Counsel Built for Business.</p>
        <p className="hero-description">
          From incorporation to IP protection — Lex Pitch delivers precise,
          practical legal solutions that move your business forward.
        </p>
        <button className="cta-button" onClick={handleEnquireNow}>
          Get Started
        </button>
      </div>
    </section>
  );
};

export default Hero;
